import React from 'react'
import { useCartStore } from '../../stores/cartStore'
import { useMenuTheme } from '@/contexts/MenuThemeContext'

export const CartSummary: React.FC = () => {
  const { subtotal, total, itemCount } = useCartStore()
  const { theme } = useMenuTheme()

  const subtotalValue = subtotal()
  const totalValue = total()
  const count = itemCount()

  return (
    <div
      className="rounded-lg p-4 space-y-3"
      style={{ backgroundColor: `${theme.textColor}08` }}
    >
      <div className="flex justify-between text-sm">
        <span style={{ color: theme.textSecondary }}>
          Subtotale ({count} {count === 1 ? 'articolo' : 'articoli'})
        </span>
        <span className="font-medium" style={{ color: theme.textColor }}>
          €{subtotalValue.toFixed(2)}
        </span>
      </div>

      <div
        className="pt-3"
        style={{ borderTopColor: theme.borderColor, borderTopWidth: '1px' }}
      >
        <div className="flex justify-between">
          <span className="text-base font-semibold" style={{ color: theme.textColor }}>
            Totale
          </span>
          <span className="text-lg font-bold" style={{ color: theme.primaryColor }}>
            €{totalValue.toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  )
}
